import { differenceInHours, isAfter, addHours, addDays } from 'date-fns';
//ASCENDING UTCs hour order for feed generation
const feedGenerationHours = [2, 8, 14, 20];
const feedProcessingDuration = 2;

const isEvocalizeFeedProcessed = (createdAt) => {
  const nextFeedDate = getNextFeedDate(createdAt);
  const dateNow = new Date();
  return isAfter(dateNow, addHours(nextFeedDate, feedProcessingDuration));
};

const nextProcessRemainingHours = (createdAt, serverDate) => {
  const nextFeedDate = getNextFeedDate(createdAt);
  const dateNow = new Date(serverDate);
  return differenceInHours(addHours(nextFeedDate, feedProcessingDuration), dateNow);
};

const getNextFeedDate = (createdAt) => {
  const parsedCreatedAt = new Date(createdAt);
  const createdAtHour = parsedCreatedAt.getUTCHours();

  let nextFeedDate = new Date(parsedCreatedAt);

  const isAfterLastFeedHour = createdAtHour >= feedGenerationHours[feedGenerationHours.length - 1];
  const nextFeedHour = isAfterLastFeedHour ?
    feedGenerationHours[0] :
    feedGenerationHours.find(generationHour => createdAtHour < generationHour);

  nextFeedDate.setUTCHours(nextFeedHour);
  nextFeedDate.setUTCMinutes(0);
  nextFeedDate.setUTCSeconds(0);
  nextFeedDate.setUTCMilliseconds(0);

  if (isAfterLastFeedHour) {
    nextFeedDate = addDays(nextFeedDate, 1);
  }
  return nextFeedDate;
};

export { isEvocalizeFeedProcessed, nextProcessRemainingHours };
